import { SyntheticEvent, PropsWithChildren } from "react";
import classnames from "classnames";

import { Button, Spinner, ButtonKind } from "../../../../../core/ui";
import "./UsersButton.style.scss";

interface UsersButtonProps {
  click?: (e: SyntheticEvent) => void;
  type?: "button" | "submit";
  isProcessing?: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
}

export function UsersButton({
  type = "button",
  isProcessing,
  className,
  disabled,
  children,
  click,
  label,
}: PropsWithChildren<UsersButtonProps>) {
  return (
    <Button
      className={classnames("component-users-button", { [`${className}`]: !!className })}
      disabled={disabled || isProcessing}
      kind={ButtonKind.CUSTOMIZED}
      label={label}
      click={click}
      type={type}
    >
      {isProcessing ? <Spinner visible={true} /> : children}
    </Button>
  );
}
